/* import __COLOCATED_TEMPLATE__ from './categories-with-featured-topics.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./categories-with-featured-topics.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));